<script lang="ts">
    import { faPlus } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte'
    import Popover from '../../_common/popover.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import { GridButton } from '../../_common/z/zgrid'
    import { Referral } from '../../../modules/eventsApi/referrals/referral'
    import Referrals from './referrals.svelte'

    export let referral: Referral = null
    export let disabled: boolean = false
    export let label = ''

    let acts: GridButton[] = [{ callback: newReferral, label: null, icon: faPlus, color: 'green' }]

    let referrals: Referral[] = []

    async function loadReferrals() {
        referrals = await window.api.events.referrals.getAll()
    }

    $: referralOptions = referrals.map((el) => ({ value: el.referralId, label: el.label || '' }))
    $: selectedId = referral?.referralId || null

    function onChange(ev) {
        referral = referrals.find((el) => el.referralId === ev.detail.value) || null
    }

    let showForm = false
    function newReferral() {
        referral = new Referral()
        showForm = true
    }

    async function hideForm(event) {
        showForm = false
        await loadReferrals()
        if (event.detail?.referralId) {
            referral = event.detail
        }
    }

    onMount(async () => {
        await loadReferrals()
        if (referral?.referralId) {
            referral = referrals.find((el) => el.referralId === referral.referralId) || referral
        }
    })
</script>

{#if showForm}
    <Popover on:close={hideForm} title="Origens" width="600px">
        <Referrals referralId={referral.referralId} form={true} on:close={hideForm} />
    </Popover>
{/if}

<Zinput type="select" {label} {disabled} options={referralOptions} value={selectedId} on:change={onChange} {acts} />
